@if(data?.file?.type?.includes('pdf')){
<div class="pdf-container">
  <embed [src]="pdfSrc" type="application/pdf" />
</div>
}@else {
<img [src]="this.data.src" style="object-fit: cover; height: 80vh" />
}
